import React, { Component } from 'react';
import { get } from 'lodash';
import { shape, number, string, func, bool, oneOfType, element } from 'prop-types';
import cx from 'classnames';

import styles from './styles.scss';
import DatePicker from 'components/DatePicker';

export default class DateRange extends Component {

    static propTypes = {
        campaign: shape({
            campaign_id: number   
        }),
        typePicker: string.isRequired,
        title: oneOfType([string, element]),
        styleForDateRange: shape({
            container: string,
            styleForTitle: string,
            styleIconCalendar: string
        }),
        onChange: func,
        changeDateRange: func.isRequired,
        advertiser: shape({
            advertiser_id: number
        }),
        showToast: func,
        customSelect: bool,
        isShowDataCollected: bool,
        disabled: bool,
        selectedTimezone: string,
        isShowCalendarIcon: bool,
        useWatchlistsAsAdSource: bool
    }

    render() {
        const {
            styleForDateRange = {},
            campaign,
            typePicker,
            title,
            selectedTimezone,
            useWatchlistsAsAdSource,
            isShowCalendarIcon,
            ...props
        } = this.props;
        return (
            <div className={styleForDateRange.container}>
                <div className={cx(styles.title, styleForDateRange.styleForTitle)}>
                    {title}
                </div>
                <DatePicker
                    campaign={campaign}
                    typePicker={{name: typePicker}}
                    selected={get(campaign, [typePicker, "selected"])}
                    value={get(campaign, [typePicker, "value"])}
                    iconClassName={styleForDateRange.styleIconCalendar}
                    selectedTimezone={selectedTimezone}
                    useWatchlistsAsAdSource={useWatchlistsAsAdSource}
                    isShowCalendarIcon={isShowCalendarIcon}
                    {...props}
                />
            </div>
        );
    }
}
